import {Component, OnInit} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {AngularFireAuth} from 'angularfire2/auth'
import {BrandService} from 'app/brand/brand.service'

const PROJECTCOLLECTION = 'projects'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  projects: any
  newProjectId: string

  constructor(
    private firestore: AngularFirestore,
    public auth: AngularFireAuth,
    public brandService: BrandService
  ) {
    this.newProjectId = this.firestore
      .collection(PROJECTCOLLECTION)
      .ref.doc().id
    this.firestore
      .collection(PROJECTCOLLECTION, ref =>
        ref.orderBy('date', 'desc').limit(50)
      )
      .valueChanges()
      .subscribe(projects => {
        this.projects = projects.map(project => {
          project['brand'] = this.brandService.getBrand(project['brand'])
          project['client'] = this.brandService.getBrand(project['client'])
          return project
        })
      })
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/dashboard/dashboard.component.ts